// extracted by mini-css-extract-plugin
export default {"container":"I--z","tab":"J--z","selected":"K--z"};